import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, PropType, watch } from 'vue'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetGliderAssociationRow',
  props: {
  onlyOnGoing: {
    type: Boolean,
    default: false
  },
  association: {
    type: Object as PropType<{ key: string; gliKey: string | null; misId: number | null }>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;



const gliders = computed(() =>
  [
    ...new Set(
      store.myGetters.missions
        .filter(
          (m) =>
            (store.myGetters.filterEnseignePredicate(m) || m.misId == props.association.misId) &&
            (!props.onlyOnGoing || m.misActifOn == props.onlyOnGoing)
        )
        .map((m) => {
          return { id: m.gliId, key: m.gliKey?.trim()! }
        })
    )
  ].sort((a, b) => (a.key > b.key ? 1 : -1))
)
const missions = computed(() =>
  store.myGetters.missions
    .filter(
      (m) =>
        (store.myGetters.filterEnseignePredicate(m) || m.misId == props.association.misId) &&
        (!props.onlyOnGoing || m.misActifOn == props.onlyOnGoing) &&
        (!props.association.gliKey || m.gliKey?.trim() == props.association.gliKey)
    )
    .sort((a, b) => ((a?.misLibelle ?? '') < (b?.misLibelle ?? '') ? 1 : -1))
)

function misLibelle(mis: any) {
  const parts = mis.misLibelle.split('_')
  return parts.at(-1)
}

watch(
  () => props?.association?.gliKey,
  (newVal, oldVal) => {
    if (newVal != oldVal) {
      nextTick(() => {
        if (!props.association.misId || !missions.value?.some((m) => m.misId == props.association.misId)) {
          props.association.misId = missions.value?.at(0)?.misId ?? null
        }
      })
    }
  }
)

return { __sfc: true,props, gliders, missions, misLibelle }
}

})